import BadgeDot from "@/components/shared/BadgeDot";

export default function StateBadgeDot({ state }: { state: string }) {
  function variantForState(state: string) {
    const lowercaseState = state.toLowerCase();
    switch (lowercaseState) {
      case "deployed":
      case "ready":
      case "done":
      case "running":
      case "available":
      case "verified":
        return "green";
      case lowercaseState.match(/.*errored$/)?.input:
        return "red";
      case "removing":
      case "removed":
        return "gray";
      default:
        return "yellow";
    }
  }

  return <BadgeDot variant={variantForState(state)} />;
}
